module.exports = __webpack_public_path__ + "static/img/answer_wrong.24f5fb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/answer_wrong.png
// module id = Pvu0
// module chunks = 1